import { T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS } from './TYPES'

const DE_TERMS_AND_CONDITIONS_PAGE_CONSTANTS: T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS =
  {
    PAGE_KICKER: 'GRIFFYREADS',
    PAGE_TITLE: 'Allgemeine Geschäftsbedingungen',
    PAGE_CONTENT: [
      {
        TITLE: 'Einleitung',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Willkommen bei GriffyReads. Diese Allgemeinen Geschäftsbedingungen ("Bedingungen") regeln Ihre Nutzung unserer Quiz-basierten Anwendung für Kinder und Erwachsene ("die App"). ',
              'Das Ziel der App ist es, das Offline-Lesen bei Kindern zu fördern. Zu diesem Zweck bietet die App eine Datenbank mit Multiple-Choice-Quizfragen, die das Leseverständnis überprüfen. Gleichzeitig fungiert sie als Community-Plattform, auf der jeder erwachsene Nutzer (Eltern, Lehrkräfte usw.) Quizfragen hochladen kann.',
              'Kinder - in der App als „Abenteurer“ bezeichnet - nutzen die Plattform, indem sie ein bestimmtes Buch auswählen, es offline lesen und anschließend ein Quiz mit fünf Multiple-Choice-Fragen ausfüllen, das ihr Textverständnis testet. Für jede richtige Antwort erhalten sie Punkte, die zur Entwicklung ihres Characters  - eines jungen Greifs namens Griffy - beitragen. Die Abenteurer können alleine spielen oder an von erwachsenen Nutzern organisierten Events und Wettbewerben teilnehmen - gemeinsam mit anderen Abenteurern. Die Plattform enthält nur bestimmte identifizierende Informationen zu jedem Buch (z. B. Autor, Verlag, Titelbild), jedoch nicht das Buch selbst.'
            ]
          }
        ]
      },
      {
        TITLE: 'Nutzer und Registrierung',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Die App ist für die Nutzung durch Erwachsene und Kinder bestimmt. „Erwachsener“ bezeichnet eine Person, die das gesetzliche Mindestalter von 18 Jahren erreicht hat. Kinder unter 13 Jahren dürfen die App nur unter der Aufsicht eines Erwachsenen nutzen.',
              'Erwachsene Nutzer können Wettbewerbe für Kinder erstellen und werden ermutigt, neue Quizfragen hochzuladen.',
              'Um die App zu nutzen, müssen sich erwachsene Nutzer registrieren, indem sie bestimmte Daten angeben. Zum Einloggen verwenden sie eine E-Mail-Adresse und ein Passwort. Nur Erwachsene dürfen ein Konto registrieren. Nach der Registrierung können sie ein Kinderkonto (Abenteurer) erstellen. Danach können sich die Abenteurer selbstständig in ihr Konto einloggen.',
              'Nach der Registrierung gibt es eine 14-tägige Testphase. Erwachsene Nutzer sollten ein Abonnement wählen, um nach Ablauf der Testphase vollen Zugriff auf die App zu erhalten.',
              'Erwachsene Nutzer sind dafür verantwortlich, die Richtigkeit der bei der Registrierung angegebenen Informationen sicherzustellen.'
            ]
          }
        ]
      },
      {
        TITLE: 'Nutzung der App',
        CONTENT: [
          {
            TYPE: 'LIST',
            CONTENT: [
              'Teilnahme an Quizzen: Kinder (Abenteurer) lesen das ausgewählte Buch (bei jüngeren Kindern wird es ihnen vorgelesen) und füllen anschließend Quizze in der App aus, um ihr Textverständnis zu testen. Jede richtige Antwort bringt Punkte ein, die dazu beitragen, dass ihr Griffy stärker und größer wird. Das Sammeln von Punkten führt außerdem zu Levelaufstiegen und zur Weiterentwicklung des Charakters.',
              'Wettbewerbe und Events: Erwachsene Nutzer können Wettbewerbe erstellen, an denen Abenteurer teilnehmen können (in der Regel werden diese Wettbewerbe von Lehrkräften für ihre Schüler organisiert). Die Administratoren der App können sogenannte Events erstellen, bei denen es sich um öffentliche Wettbewerbe handelt, die typischerweise für größere Gruppen (z. B. Altersgruppen) zugänglich sind.',
              'Alle Teilnehmenden können ihre Platzierung auf der Bestenliste einsehen (der Organisator des Wettbewerbs oder der Event hat die Möglichkeit, die Bestenliste zu anonymisieren), und die bestplatzierten Teilnehmenden erhalten Abzeichen.',
              'Virtuelle Bibliothek und Büchertausch: Kinder können in der App eine „virtuelle Bibliothek“ mit Büchern anlegen, die sie bereits besitzen, und ihre Bereitschaft zum Teilen dieser Bücher mit Freunden innerhalb der App anzeigen.',
              'Freundesliste: Kinder können andere Kinder zu ihrer Freundesliste hinzufügen, wodurch sie die Bücher der anderen sehen und den Büchertausch sowie die Kommunikation erleichtern können.'
            ]
          }
        ]
      },
      {
        TITLE: 'Inhalt und Verhalten',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Erwachsene Nutzer sind für die von ihnen bereitgestellten Inhalte und ihr Verhalten während der Nutzung der App verantwortlich. Unangemessene, beleidigende oder schädliche Inhalte oder Verhaltensweisen können zur Sperrung oder Kündigung des Kontos führen. ',
              'Durch das Hochladen, Einreichen oder anderweitige Zurverfügungstellen von Quizfragen oder damit zusammenhängenden Inhalten ("Nutzerinhalte") über die App erklären sich erwachsene Nutzer damit einverstanden, dass diese Inhalte zum alleinigen und ausschließlichen geistigen Eigentum von Adonis Consultancy werden. Erwachsene Nutzer übertragen hiermit unwiderruflich alle Rechte, Titel und Interessen an und an den Nutzerinhalten an Adonis Consultancy, einschließlich und ohne Einschränkung aller Urheberrechte und sonstigen geistigen Eigentumsrechte daran. ',
              'Erwachsene Nutzer erkennen ferner an und stimmen zu, dass Adonis Consultancy das uneingeschränkte Recht hat, die Nutzerinhalte ohne Entschädigung, Zuschreibung oder weitere Mitteilung an sie für kommerzielle oder andere Zwecke zu verwenden, zu reproduzieren, zu modifizieren, zu verteilen, anzuzeigen, auszuführen und anderweitig zu nutzen. ',
              'Durch das Einreichen von Inhalten erklären und garantieren erwachsene Nutzer, dass sie über alle erforderlichen Rechte und Berechtigungen verfügen, um diese Übertragung zu gewähren, und dass der Inhalt keine Rechte Dritter verletzt.'
            ]
          }
        ]
      },
      {
        TITLE: 'Datenschutz',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Ihre Nutzung der App unterliegt auch unserer Datenschutzerklärung, in der erläutert wird, wie der Verantwortliche Ihre personenbezogenen Daten erfasst, verwendet und schützt.'
            ]
          }
        ]
      },
      {
        TITLE: 'Abonnement und Zahlung',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Die App funktioniert nach einem Abonnementmodell, bei dem erwachsene Nutzer einen bestimmten Betrag entsprechend einem Abonnementplan zahlen, um ihren Kindern nach Ablauf der 14-tägigen Testphase Zugang zur Plattform zu ermöglichen. Es werden mehrere Abonnementpläne angeboten. Zahlungen werden über PayPal abgewickelt. Mit dem Abschluss eines bestimmten Abonnementplans erklären sich erwachsene Nutzer damit einverstanden, die entsprechenden Abonnementgebühren sowie alle anfallenden Steuern zu bezahlen.'
            ]
          }
        ]
      },
      {
        TITLE: 'Änderungen an der App',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Wir behalten uns das Recht vor, die App vorübergehend oder dauerhaft mit oder ohne Vorankündigung zu ändern oder einzustellen. Wir haften nicht für Änderungen, Aussetzung oder Einstellung der App.'
            ]
          }
        ]
      },
      {
        TITLE: 'Beendigung',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Wir behalten uns das Recht vor, Ihren Zugriff auf die App nach unserem alleinigen Ermessen und ohne vorherige Ankündigung zu beenden oder auszusetzen, wenn wir der Ansicht sind, dass Ihr Verhalten gegen diese Bedingungen verstößt oder anderen Nutzern bzw. der App schadet.'
            ]
          }
        ]
      },
      {
        TITLE: 'Haftungsbeschränkung',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Soweit gesetzlich zulässig, haftet GriffyReads nicht für indirekte, zufällige, besondere, Folge- oder Strafschäden, die sich aus der Nutzung der App ergeben oder damit in Zusammenhang stehen.'
            ]
          }
        ]
      },
      {
        TITLE: 'Anwendbares Recht',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Diese Bedingungen unterliegen dem belgischen Recht und sind entsprechend auszulegen, unabhängig davon, ob dessen Kollisionsnormen die Anwendung eines anderen Rechts vorschreiben.'
            ]
          }
        ]
      },
      {
        TITLE: 'Kontaktieren Sie uns',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Wenn Sie Fragen oder Bedenken zu diesen Bedingungen haben, kontaktieren Sie uns bitte unter contact@griffyreads.com.'
            ]
          }
        ]
      }
    ]
  }

export default DE_TERMS_AND_CONDITIONS_PAGE_CONSTANTS
